import { ReactNode } from "react";
import { PrismLoading } from "@prism-ui/react";
import "./Loader.css";

type Props = {
  children?: ReactNode
}
const Loader = ({children}:Props) => {
  return (
    <div className="loader-container">
      <PrismLoading as="spinner" size="lg" container="inline" />
      <span className="loader-text">{children || "Loading..."}</span>
    </div>
  )
}

export default Loader